const AMPLITUDE_OPTIONS = {
  transport: navigator.sendBeacon ? 'beacon' : 'fetch',
  autocapture: {
    attribution: true,
    pageViews: true,
    sessions: true,
    formInteractions: true,
    fileDownloads: true,
    elementInteractions: {
      cssSelectorAllowlist: ['a', 'button', '[data-amplitude-track]'],
      actionClickAllowlist: [],
      debounceTime: 2_000,
    },
    networkTracking: {
      ignoreAmplitudeRequests: true,
    },
  },
  trackingOptions: {
    ipAddress: true,
    language: true,
    platform: true,
  },
};

export  {
  AMPLITUDE_OPTIONS,
};